import _ from 'lodash';

import * as constants from './Points.constants';
import * as services from './Points.service';

const state = {
  points: {},
  goodsList: [],

  payStep: '',

  yzResultEntity: {},
  pointsYzStatus: false,

  paypalURL: '',
  pointsPaypalInfo: {},
  pointsPaypalResult: {},
  isPaypalSubmitting: false,

  isRequest: false,
  isRequestLong: false,
};

const mutations = {
  [constants.GET_MY_POINTS_SUCCESS](state, points) {
    if (null !== points && undefined !== points) {
      state.points = points;
    }
  },

  [constants.GET_POINTS_GOODS_LIST_SUCCESS](state, goodsList) {
    if (null !== goodsList && undefined !== goodsList) {
      state.goodsList = goodsList;
    }
  },

  [constants.SET_PAY_STEP](state, payStep) {
    state.payStep = payStep;
  },

  [constants.GET_POINTS_YZ_QR_CODE_SUCCESS](state, yzResultEntity) {
    if (null !== yzResultEntity && undefined !== yzResultEntity) {
      state.yzResultEntity = yzResultEntity;
    }
  },

  [constants.GET_POINTS_YZ_STATUS_SUCCESS](state, pointsYzStatus) {
    if (null !== pointsYzStatus && undefined !== pointsYzStatus) {
      state.pointsYzStatus = pointsYzStatus;
    }
  },

  [constants.MAKE_POINTS_PAYPAL_URL_SUCCESS](state, paypalURL) {
    if (null !== paypalURL && undefined !== paypalURL) {
      state.paypalURL = paypalURL;
    }
  },

  [constants.GET_POINTS_PAYPAL_INFO_SUCCESS](state, pointsPaypalInfo) {
    if (null !== pointsPaypalInfo && undefined !== pointsPaypalInfo) {
      state.pointsPaypalInfo = pointsPaypalInfo;
    }
  },

  [constants.GET_POINTS_PAYPAL_RESULT_SUCCESS](state, pointsPaypalResult) {
    if (null !== pointsPaypalResult && undefined !== pointsPaypalResult) {
      state.pointsPaypalResult = pointsPaypalResult;
    }
  },

  [constants.SET_IS_PAYPAL_SUBMITTING](state, isPaypalSubmitting) {
    state.isPaypalSubmitting = isPaypalSubmitting;
  },

  [constants.SET_IS_REQUEST_STATUS](state, status) {
    state.isRequest = status;
  },

  [constants.SET_IS_REQUEST_LONG_STATUS](state, status) {
    state.isRequestLong = status;
  },
};

const actions = {
  async getMyPoints({ dispatch, commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getMyPoints(payload);
    if (200 === res.data.status) {
      const points = res.data.data;
      commit(constants.GET_MY_POINTS_SUCCESS, points);
      const payloadBonusPoint = {
        bonusPoint: points.mypoints,
      };
      dispatch('updateUserInfo', payloadBonusPoint, { root: true });
    }
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async getPointsGoodsList({ commit }, payload) {
    const res = await services.getPointsGoodsList(payload);
    if (200 === res.data.status) {
      commit(constants.GET_POINTS_GOODS_LIST_SUCCESS, res.data.data);
    }
  },

  async makePointsYzQrcode({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.makePointsYzQrcode(payload);
    if (200 === res.data.status) {
      commit(constants.GET_POINTS_YZ_QR_CODE_SUCCESS, res.data.data);
    }
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async getPointsYzStatus({ commit }, payload) {
    const res = await services.getPointsYzStatus(payload);
    if (200 === res.data.status) {
      commit(constants.GET_POINTS_YZ_STATUS_SUCCESS, res.data.data);
    }
  },

  async getPointsYzStatusOnce({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getPointsYzStatusOnce(payload);
    if (200 === res.data.status) {
      commit(constants.GET_POINTS_YZ_STATUS_SUCCESS, res.data.data);
    }
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },

  async makePointsPaypalUrl({ commit }, payload) {
    const res = await services.makePointsPaypalUrl(payload);
    if (200 === res.data.status && res.data.data && res.data.data.paypalURL) {
      commit(constants.MAKE_POINTS_PAYPAL_URL_SUCCESS, res.data.data.paypalURL);
    }
  },

  async getPointsPaypalInfo({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_LONG_STATUS, true);
    const res = await services.getPointsPaypalInfo(payload);
    if (200 === res.data.status) {
      commit(constants.GET_POINTS_PAYPAL_INFO_SUCCESS, res.data.data);
    }
    commit(constants.SET_IS_REQUEST_LONG_STATUS, false);
  },

  async getPointsPaypalResult({ commit }, payload) {
    commit(constants.SET_IS_REQUEST_STATUS, true);
    const res = await services.getPointsPaypalResult(payload);
    if (200 === res.data.status) {
      commit(constants.GET_POINTS_PAYPAL_RESULT_SUCCESS, res.data.data);
    }
    commit(constants.SET_IS_REQUEST_STATUS, false);
  },
};

const getters = {
  mypoints: (state) => state.points.mypoints,

  pointsChanges: (state) => {
    let pointsChanges = _.map(state.points.pointsChanges, (pointsChange) => [
      `_${pointsChange.display_type}`,
      pointsChange.points,
    ]);
    pointsChanges = _.fromPairs(pointsChanges);
    pointsChanges['_4_5_10_100'] = 0;
    pointsChanges['_4_5_10_100'] += pointsChanges['_4'] ? pointsChanges['_4'] : 0;
    pointsChanges['_4_5_10_100'] += pointsChanges['_5'] ? pointsChanges['_5'] : 0;
    pointsChanges['_4_5_10_100'] += pointsChanges['_10'] ? pointsChanges['_10'] : 0;
    pointsChanges['_4_5_10_100'] += pointsChanges['_100'] ? pointsChanges['_100'] : 0;
    return pointsChanges;
  },

  pointsLogs: (state) => {
    if (state.points.pointsLogs) {
      return _.map(state.points.pointsLogs, (pointsLog) => ({
        ...pointsLog,
        c_isPositive: pointsLog.bonusPoint > 0,
      }));
    } else {
      return [];
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
